import { useState } from 'react';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { SmileIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';

export default function EmojiPicker({ onEmojiSelect }) {
  const [open, setOpen] = useState(false);

  const handleEmojiSelect = (emoji) => {
    onEmojiSelect(emoji.native);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button size='xs' variant='ghost' title='Insert emoji'>
          <SmileIcon className='h-5 w-5' />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className='w-auto border-0 p-0'
        side='top'
        align='start'
        sideOffset={8}
      >
        <Picker
          data={data}
          onEmojiSelect={handleEmojiSelect}
          theme='dark'
          previewPosition='none'
          skinTonePosition='search'
          maxFrequentRows={2}
        />
      </PopoverContent>
    </Popover>
  );
}
